import BlogPostTile from 'components/BlogPostTile';
import Paginator from 'components/Paginator';
import StaticPageHeader from 'components/StaticPageHeader';
import {NextSeo} from 'next-seo';

const BlogHome = ({allPosts, page}) => {
  return (
    <>
      <NextSeo title="Polar Signals Blog" />
      <StaticPageHeader
        title="Our Blog"
        subTitle="Welcome to the Polar Signals blog where we write about profiling, performance, and company culture."
      />

      <div className="container mx-auto my-20 px-4">
        <Paginator allItems={allPosts} defaultPage={page}>
          {currentItems => {
            return (
              <div className="grid grid-cols-1 gap-6 text-white lg:grid-cols-2">
                {currentItems.map((post, index) => (
                  <BlogPostTile key={post.link} post={post} index={index} />
                ))}
              </div>
            );
          }}
        </Paginator>
      </div>
    </>
  );
};

export default BlogHome;
